import { i as e, n as t, r as n, t as r } from "./src-Dyq02gZZ.js";
import { getClient as i, registerEntityEndpoint as a } from "@editor/ui-utils";
//#region src/services/hub-pages.service.ts
var o = "hub-pages", s = a(o), { getEntity: c, listEntities: l, putEntity: u, postEntity: d, deleteEntity: f } = s, p = async (e, t = {}) => l({ params: {
	search: e,
	...t
} }), m = async (e) => c(e), h = async (e) => d(e), g = async (e) => {
	let { _id: t, ...n } = e;
	return u(t, n);
}, _ = async (e) => f(e), v = async (e, t) => s.getEntity("resolved-references", { params: {
	hubPageIds: e,
	brand: t
} }), y = (e) => ({
	title: "",
	brand: e,
	tagEntitiesUuids: [],
	relatedHubPagesUuids: [],
	urlSlug: "",
	paths: [],
	contentsRef: [],
	overviewTitle: "",
	pageMetadata: {
		type: "HubPages",
		minScoreThreshold: 0,
		metaTitle: "",
		metaDescription: "",
		isNoIndex: !1,
		isNoFollow: !1
	},
	state: "draft",
	legacy: {
		source: "vibe",
		isEditableInCTF: !0,
		hasBeenModifiedInCTF: !0,
		isRenderedByCTF: !0
	},
	showOnListPage: !1
}), b = async (e) => (await i().get(`/cms/hub-pages/${e}/check-path-conflict`)).data;
//#endregion
export { r as HubPagesContentBlock, t as HubPagesListView, s as HubPagesService, n as PeopleProfileBlock, b as checkPathConflict, _ as deleteHubPages, o as entityEndpoint, y as getEmptyHubPages, m as getHubPages, p as getHubPagesList, v as getResolvedReferencesForHubPages, e as hubPagesModule, h as postHubPages, g as putHubPages };

//# sourceMappingURL=index.es.js.map